import { render, staticRenderFns } from "./TermsOfUseView.vue?vue&type=template&id=7daea379"
import script from "./TermsOfUseView.vue?vue&type=script&lang=ts"
export * from "./TermsOfUseView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports